<template>
    <div class="w-50 gray-background column" v-if="campaign && showTemplate">
        <div class="side-container mx-auto">
            <div class="partner-img">
                <Thumbnail 
                    :data = "campaign"
                    size = "medium" 
                    />
            </div>
            <div class="partner-campaign mt-3">
                <p class="c6 p1b">
                    {{campaign.title}}
                </p>
            </div>
            <div id="not-sceduled-updates-error" class="pt-4 error-state-texts" v-if="errors['no-update-date-partner']">
                <p>This campaign hasn't yet scheduled any updates.</p>
                <p>You can still request CrossProm through a message.</p>
            </div>
            <div v-if="!errors['no-update-date'] && !errors['no-update-date-partner'] && !pending">
                <Dropdown
                    :error-state="errors['already-requested-partner']"
                    heading = "Pick the date you want to be featured*"
                    id="partner-dates-dropdown-modal"
                    :text = "selectedSpot && selectedSpot.date || 'Partner Update Dates'"
                    :items="scheduler"
                    key-placeholder="partner-update-dates"
                    :campaign="ownerCampaign"
                    @setItem = "setSpots"
                    :max-height="150"
                />
                <div v-if="errors['already-requested-partner']" class="pt-2">
                        <p class="error-state-texts">
                            You have already requested cross-promotion for this date
                        </p>
                    </div>
                <div
                    class="spots-box mt-4"
                    :class="{'error-state': errors['pick-spot-partner'] || errors['all-spots-are-taken-partner']}"
                    v-if="spots && spots.length && !errors['already-requested-partner']">
                        <p class="lab c6 mb-0">
                            Pick the spot*
                        </p>
                        <SpotsList
                            id="partner-campaign-spots"
                            @selectSpot="selectSpot"
                            :spots="spots"
                            :selected-spot="selectedSpot"
                        />
                </div>
                <p
                    v-if="errors['all-spots-are-taken-partner']"
                    class="error-state-texts">
                        All spots on this date are taken.<br/>
                        Send a message suggesting to add an update date or pick another date
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import Dropdown from './Crumbs/Dropdown';
import SpotsList from "./Crumbs/SpotsList";
import { Loader } from '../../components/Icons'
import Thumbnail from '../Theme/Thumbnail'


import { watch, ref } from '@vue/composition-api';
import { useRouter, useSpots, usePartner, useErrors } from '../../core/hooks'

export default {
    name: 'PartnerPart',
    components: {
        Dropdown,
        SpotsList,
        Loader,
        Thumbnail
    },
    props: {
        ownerCampaign: Object,
        showTemplate: Boolean,
        pending: Boolean
    },
    setup(props, context){
        
        const { campaign } = usePartner();
        const { route, router } = useRouter();
        const errors = useErrors().messages;

        const {
            spots,
            selectedSpot,
            scheduler,
            selectSpot,
            setSpots,
        } = useSpots(route.value.query.project_id, true);


        // watch variable changes, gather them in an object and send it to index file
        watch([campaign, selectedSpot, spots], ([campaign, selectedSpot, spots]) => {
            context.emit('newPartner', {
                campaign, 
                selectedSpot,
                spots
            })
        }, {immediate: true})


        return {
            campaign,
            spots,
            selectedSpot,
            scheduler,
            selectSpot,
            setSpots,
            errors
        }
    }
}
</script>


<style lang="scss" scoped>
    .side-container {
        margin-top: 28px;
        width: 207px;
        img {
            width: 100px;
            height: 100px;
            border-radius: 50%;
            object-fit: cover;
        }
    }
</style>